import {createFileRoute} from '@tanstack/react-router';
import {
  HomeLayout,
  type ProjectsSortBy,
} from '@features/flow/components/HomeLayout';
import {ProjectsView} from '@features/flow/components/ProjectsView';
import type {ProjectsFilter} from '@features/flow/types/projectsFilter';
import {parseAsStringLiteral, useQueryState} from 'nuqs';

export const Route = createFileRoute('/projects')({component: ProjectsPage});

const filterParser = parseAsStringLiteral<ProjectsFilter>([
  'all',
  'shared-with-me',
  'created-by-me',
]).withDefault('all');

const sortByParser = parseAsStringLiteral<ProjectsSortBy>([
  'lastEdited',
  'createdAt',
]).withDefault('lastEdited');

function ProjectsPage() {
  const [filter, setFilter] = useQueryState('filter', filterParser);
  const [sortBy, setSortBy] = useQueryState('sort', sortByParser);

  return (
    <HomeLayout
      currentView='projects'
      projectsFilter={filter}
      onProjectsFilterChange={(value) => void setFilter(value)}
      projectsSortBy={sortBy}
      onProjectsSortByChange={(value) => void setSortBy(value)}
    >
      <title>Banani | Projects</title>
      <ProjectsView filter={filter} sortBy={sortBy} />
    </HomeLayout>
  );
}
